/**
 *
 * FlashCardDetail
 *
 */

import { mapState, mapActions } from 'vuex';
import _ from 'lodash';

import { FlashCardExerciseTypeMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/FlashCardExerciseTypeMixin';
import { FlashCardFilterSwitchMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/FlashCardFilterSwitchMixin';
import { DEBOUNCE_LATENCY } from '@/constants';

export default {
  name: 'FlashCardToggleRevise',

  mixins: [FlashCardExerciseTypeMixin, FlashCardFilterSwitchMixin],

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardInfo: 'flashCardInfo',
    }),
  },

  methods: {
    ...mapActions('FlashCard/FlashCardDetail', {
      ma_toggleFlashCardAddQuestionSequence: 'toggleFlashCardAddQuestionSequence',
      ma_toggleFlashCardAddQuestionRandom: 'toggleFlashCardAddQuestionRandom',
    }),

    toggleFlashCardAddQuestion() {
      let toggleFlashCardAddQuestion;
      if (this.c_isSequenceFlashCardExerciseType) {
        toggleFlashCardAddQuestion = this.ma_toggleFlashCardAddQuestionSequence;
      } else if (this.c_isRandomFlashCardExerciseType) {
        toggleFlashCardAddQuestion = this.ma_toggleFlashCardAddQuestionRandom;
      }
      if (toggleFlashCardAddQuestion) {
        toggleFlashCardAddQuestion({
          cardId: this.ms_flashCardInfo.cardId,
          addQuestion: this.c_flashCardFilterSwitch,
        });
      }
    },

    handleFilterSwitch() {
      this.handleFilterSwitchInFilter();
      this.debouncedToggleFlashCardAddQuestion();
    },
  },

  created() {
    this.debouncedToggleFlashCardAddQuestion = _.debounce(
      this.toggleFlashCardAddQuestion,
      DEBOUNCE_LATENCY
    );
  },
};
